import { Loader, LoaderSize } from "@progress/kendo-react-indicators";

export const LoadingIndicator = (props: { loading: boolean, size?: LoaderSize }) => {
  return (
    <>
        {props.loading && <Loader type="infinite-spinner" size={props.size} />}
    </>
  );
};
